import { Container, Row } from "reactstrap";
import styles from "./styles.module.scss";

export const IconCards = ({ className, post, content, title, sectionId }) => {
  return (
    post?.length >= 1 && (
      <section id={sectionId} className={`${styles.root} ${className}`}>
        <Container>
            <div className="mb-5 text-center">
              {title &&
                  <div dangerouslySetInnerHTML={{ __html: title }} />
              }
              {content &&
                  <div dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          <Row className="d-flex flex-wrap m-0">
            {post?.map((post, index) => (
              <a href={`${post.url_slug}`} className="card" key={index}>
                <div>
                  <div>
                    <img
                      src={
                        post?.image?.url
                          ? post.image?.url
                          : "/site-assets/placeholders/img-placeholder.jpg"
                      }
                      alt={post?.image?.alt}
                      className="card-img mb-4"
                      width="100%"
                      height="100%"
                    />
                    <div>{post?.title}</div>
                  </div>
                </div>
              </a>
            ))}
          </Row>
        </Container>
      </section>
    )
  );
}

export default IconCards;